import React, { Component } from 'react';
import axios from 'components/AppRequest';
import { connect } from 'react-redux';
import { setUserLogged, resetRegisterFields } from 'components/actions/authActions'
import withRouter from 'components/components/common/withRouter';
import VerificationPhoneNumber from 'components/components/common/VerificationPhoneNumber';
import TransHelper from 'components/common/translations/TransHelper';

class RegistrationFormStep2 extends Component {

  componentDidMount() {
    // Sprawdzenie czy wszystkie wymagane dane z pierwszego kroku są dostępne
    const { name, email, phone } = this.props.register;

    // Jeżeli brakuje którejkolwiek z wymaganych wartości, przekieruj do kroku 1
    if (!name || !email || !phone) {
      TransHelper.redirect(this.props, 'routes.url.registrationStep1');
    }
  }

  render() {
    return (
      <VerificationPhoneNumber
        isBooking={false}
        customerData={this.props.register}
        setUserLogged={this.props.setUserLogged}
        resetRegisterFields={this.props.resetRegisterFields}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    register: state.auth.register
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogged, resetRegisterFields }
  )(RegistrationFormStep2)
);